import styled from "styled-components";

export const BackgroundContainer = styled("div")`
  display: flex;
  justify-content: center;
  @media only screen and (max-width: 680px) {
    width: 100vw;
  }
`;

export const MainContainer = styled("div")`
  width: 100%;
  max-width: 670px;
  padding: 91px 16px 16px;
  @media only screen and (max-width: 680px) {
    padding: 48px 16px 16px;
    width: 100%;
  }
`;

export const Subcontainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 32px;
`;

export const TopContainer = styled("div")`
  display: flex;
  margin-bottom: 23px;
  padding-bottom: 24px;
  width: 100%;
  max-width: 640px;
  border-bottom: 1px solid #DDDDDD;
  @media only screen and (max-width: 680px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    margin-bottom: 25px;
  }
`;

export const Column = styled("div")`
  display: flex;
  flex-direction: column;
  width: 28.125rem;
  margin-left: 16px;
  align-items: center;
  @media only screen and (max-width: 680px) {
    width: 100%;
    margin-left: 0px;
  }

`;
export const SmallColumn = styled("div")`
  display: flex;
  flex-direction: column;
  width: 6.75rem;
  margin-left: 24px;
  justify-content: space-between;
  align-items: flex-start;

  @media only screen and (max-width: 680px) {
    align-items: center;
    margin-left:0px;
    margin-top: 18px;
  }
`;

export const TopTitle = styled("h1")`
  font-weight: 700px;
  font-size: 1.625rem;
  margin-bottom: 4px;
  width: 100%;
  letter-spacing: -1px;
  @media only screen and (max-width: 680px) {
    margin-top: 16px;
    text-align: center;
  }
`;

export const Description = styled("p")`
  color: #071E52;
  font-size: 1rem;
  width: 100%;
  margin-top: auto;
  @media only screen and (max-width: 680px) {
    text-align: center;
  }
`;

export const IconContainer = styled("div")`
  display: flex;
  margin-top: Auto;
  gap: 0.825rem;
  @media only screen and (max-width: 680px) {
    gap: 1rem;
    text-align: center;
  }
`;

export const Icon = styled('img')`
  width: 28px;
  height: 28px;
  @media only screen and (max-width: 680px) {
    width: 32px;
    height: 32px;
  }
`;

export const LogoIcon = styled("img")`
  // background-image: url("https://cdn.lu.ma/cdn-cgi/image/format=auto,fit=cover,dpr=2,quality=85,width=120,height=120/avatars/5v/f218a6f4-b05e-44e5-ae29-8d7efea37232");
  // background-position: center;
  //background-color: #f4f4f4;
  // background-size: cover;
  //border-radius: 1000px;
  width: 5rem;
  height: 5rem;
`;

export const CaseStudyContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-bottom: 56px;
  @media only screen and (max-width: 680px) {
    flex-direction: column;
    margin-bottom: 48px;
  }
`;

export const CaseStudyWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 14px;
  @media only screen and (max-width: 680px) {
    flex-direction: column;
  }
`;

export const CaseStudyCard = styled('a')`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  width: 100%;
  height: 350px;
  max-width: 203px;
  text-decoration: none;
  position:relative;
  @media only screen and (max-width: 680px) {
    flex-direction: row;
    height: 100%;
    max-width: 100%;
  }
`;

export const CaseStudyImgWrapper = styled('div')`
  display: flex;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 30vw;
    z-index: 1;
  }
`;

export const CaseStudyImg = styled("img")`
  max-width: 203px;
  max-height: 203px;
  border-radius: 8px 8px 0px 0px;
  @media only screen and (max-width: 680px) {
    width: 30vw;
    border-radius: 8px 0px 0px 8px;
  }

`;

export const CaseStudyDesc = styled("p")`
  padding: 1rem;
  font-size: 0.938rem;
  font-weight: 600;
  color: #2B2B2B;
  height: 100%;
  text-transform: capitalize;
  @media only screen and (min-width: 426px) and (max-width: 680px) {
    font-size: 1.2rem;
    width:100%;
    height:100%;
    margin: auto;
  }
`;

export const Deckcontainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  margin-bottom: 57px;
  @media only screen and (max-width: 680px) {
    margin-bottom: 48px;
  }
`;

export const Title = styled("h2")`
  font-weight: 600;
  font-size: 1.25rem;
  letter-spacing: -1px;
`;

export const DeckWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 16px;
  @media only screen and (max-width: 680px){
    flex-direction: column;
  }
`;

export const DeckCard = styled('a')`
  max-width: 312px;
  width: 100%;
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  text-decoration: none;
  @media only screen and (max-width: 680px){
    max-width: 100%;
  }
`;

export const DeckImg = styled('img')`
  width:100%;
  max-width: 100%;
  border-radius: 8px 8px 0px 0px;
`;

export const DeckLink = styled('div')`
  padding: 12px 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: #303030;
  border-radius: 0px 0px 8px 8px;
`;

export const DeckText = styled('div')`
  font-size: 1.125rem;
  font-weight: 500;
  color: #FFFFFF;
  padding-right: 7px;
  @media only screen and (max-width: 425px) {
    padding: 1px 7px 0px 1px;
    font-size: 14px;
  }
`;

export const BookButton = styled('a')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 17px;
  background: linear-gradient(90deg, #FF56E4 -20.55%, #225EFF 100%);
  border-radius: 8px;
  width: 100%;
  font-size: 1.125rem;
  font-weight: 500;
  color:#FFFFFF;
  letter-spacing: -1px;
  @media only screen and (max-width: 425px) {
    padding:15px;
    font-size:14px;
  }
`;

export const BookIcon = styled('img')`
  width:24px;
  margin-right:15px;
  @media only screen and (max-width: 425px) {
    margin-right:8px;
  }
`;

export const VideoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-content: center;
  gap: 1rem;
  width: 100%;
  position: relative;
  margin-bottom: 56px;
  @media only screen and (max-width: 680px) {
    margin-bottom: 48px;
  }
`;

export const VideoWrapper = styled ('div')`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
`;

export const Video = styled('iframe')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  }
`;

export const VideoThumbnail = styled('a')`
  max-width: 640px;
  width: 100%;
  text-decoration: none;
  position: relative;
`;

export const HiringContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 56px;
  gap: 1rem;
  @media only screen and (max-width: 680px) {
    margin-bottom: 48px;
  }
`;

export const HiringButton = styled('a')`
  display: flex;
  width: 100%;
  justify-content:center;
  padding: 17px;
  background: #FFFFFF;
  border: 1px solid #2B2B2B;
  border-radius: 8px;
  color: #2B2B2B;
  text-decoration: none;
`;

export const FontButton = styled('p')`
  font-weight: 500;
  font-size: 1.125rem;
  @media only screen and (max-width: 425px) {
    font-size: 14px;
  }
`;

export const MerchContainer = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  margin-top: 56px;
  gap: 16px;
  margin-bottom: 56px;
  @media only screen and (max-width: 680px) {
    margin-bottom: 48px;
  }
`;

export const MerchBanner = styled('img')`
  max-width: 640px;
  width:100%;
  border-radius: 8px;
`;

export const TokpedButton = styled('a')`
  display: flex;
  width: 100%;
  max-height:56px;
  padding: 12px 52px 12px 12px;
  background: #42B549;
  border: 2px solid #419B46;
  border-radius: 8px;
  color: #FFFFFF;
  text-decoration: none;
  letter-spacing: -1px;
  @media only screen and (max-width: 680px) {
    padding: 8px;
  }
`;

export const FontLogoButton = styled('p')`
  font-weight: 500;
  font-size: 1.125rem;
  margin-left: 8px;
  width: 100%;
  text-align: center;
 padding: 4px 0px;
  @media only screen and (max-width: 425px) {
    font-size: 15px;
    margin-left: 4px;
    letter-spacing: -1px;
    vertical-align: middle;
    padding: 9px 0px 0px;
  }
`;

export const LogoButton = styled('img')`
  max-width: 32px;
  width:100%;
  @media only screen and (max-width: 425px) {
    max-width: 40px;
  }
`;

export const ShopeeButton = styled('a')`
  display: flex;
  width: 100%;
  max-height:56px;
  padding: 12px 52px 12px 12px;
  background: linear-gradient(90deg, #FF6633 0%, #FD5D32 33.04%, #F7432E 87.82%, #F53D2D 99.44%);
  border: 2px solid #D5451E;
  border-radius: 8px;
  color: #FFFFFF;
  text-decoration: none;
  @media only screen and (max-width: 680px) {
    padding: 8px;
  }
`;